import React, { useState } from 'react';
import { IioTable } from '../../components/IioTable';
import { useProject } from '../../hooks/useProject';
import { FilterInput } from '../../components/FilterInput';
import { NewCustodianModal } from './NewCustodianModal';

interface Props {
  projectId: string;
  onCustodianClick: (name: string) => void;
}

export function CustodiansTab({ projectId, onCustodianClick }: Props) {
  const { data: project } = useProject(projectId);
  const [nameFilter, setNameFilter] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  const custodians = project?.custodians ?? [];
  const filtered = custodians.filter(c =>
    c.name.toLowerCase().includes(nameFilter.toLowerCase())
  );

  return (
    <>
      <h2>
        <i className="fas fa-user" aria-hidden="true" />{' '}
        {project?.name} Custodians
      </h2>

      <div className="row">
        <div className="col-md-8">
          <div className="btn-toolbar">
            <button
              className="btn btn-primary"
              onClick={() => setShowAddModal(true)}
            >
              Add Custodian <i className="fas fa-plus-circle" aria-hidden="true" />
            </button>
            <FilterInput value={nameFilter} onChange={setNameFilter} />
          </div>
        </div>
        <div className="col-md-4" style={{ textAlign: 'right' }}>
          <p className="lead">You have {custodians.length} Custodians</p>
        </div>
      </div>

      <IioTable condensed>
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {filtered.map(c => (
            <tr key={c.id}>
              <td>
                <a style={{ cursor: 'pointer' }} onClick={() => onCustodianClick(c.name)}>{c.name}</a>
              </td>
            </tr>
          ))}
        </tbody>
      </IioTable>

      {showAddModal && project && (
        <NewCustodianModal
          projectId={projectId}
          projectName={project.name}
          existingNames={custodians.map(c => c.name)}
          onClose={() => setShowAddModal(false)}
        />
      )}
    </>
  );
}
